import React from "react";
import { Button } from "semantic-ui-react";
import styled from "styled-components";

const StyledButton = styled(Button)`
  border-radius: 20px !important;
  padding: 11px !important;
`;

const PillButton = (props) => {
  return <StyledButton {...props} />;
};

export default PillButton;
